var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card shadow-sm",
      attrs: { role: "button" },
      on: {
        click: function($event) {
          return _vm.selectJobPost(_vm.jobPost)
        }
      }
    },
    [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "d-flex text-secondary" }, [
          _c("div", { staticClass: "flex-fill" }, [
            _vm._v("Job #" + _vm._s(_vm.jobPost.code))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-fill text-right" }, [
            _vm._.size(_vm.jobPost.job_post_notification_log) > 0
              ? _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("prettyDate")(
                          _vm._.head(_vm.jobPost.job_post_notification_log)
                            .created_at
                        )
                      ) +
                      "\n        "
                  )
                ])
              : _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("prettyDate")(_vm.jobPost.post_date)) +
                      "\n        "
                  )
                ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "job-post-title py-3" }, [
          _vm._v(_vm._s(_vm.jobPost.title))
        ]),
        _vm._v(" "),
        _c("div", [
          _c("i", { staticClass: "fas fa-map-marker-alt -status-alert" }),
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("multiLangName")(_vm.jobPost.address_province)) +
              " "
          ),
          _vm.jobPost.distric ? _c("span", [_vm._v(" - ")]) : _vm._e(),
          _vm._v(
            " " +
              _vm._s(_vm._f("multiLangName")(_vm.jobPost.district)) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "-status-alert mt-2" }, [
          _c("i", { staticClass: "fab fa-bitcoin" }),
          _vm._v(" "),
          _c("b", [
            _vm._v(
              _vm._s(_vm._f("currency")(_vm.jobPost.min_salary)) +
                " - " +
                _vm._s(_vm._f("currency")(_vm.jobPost.max_salary)) +
                " / " +
                _vm._s(_vm.salaryType(_vm.jobPost.salary_type))
            )
          ])
        ]),
        _vm._v(" "),
        _vm.jobUser &&
        (_vm.jobPost.job_users.length > 0 || _vm.isInterestedJob(_vm.jobPost))
          ? _c("div", [
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex" }, [
                _c("div", { staticClass: "flex-fill" }, [
                  _vm.jobPost.job_users.length > 0
                    ? _c("span", [
                        _vm._v(
                          "\n                    มี " +
                            _vm._s(_vm.jobPost.job_users.length) +
                            " คนสนใจ\n                  "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-fill text-right -status-accepted" },
                  [
                    _vm.isInterestedJob(_vm.jobPost)
                      ? _c("span", [
                          _c("i", { staticClass: "fas fa-check-circle" }),
                          _vm._v(" คุณสนใจงานนี้\n                  ")
                        ])
                      : _vm._e()
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0)
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row no-gutters mt-4" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("button", { staticClass: "btn btn-block btn-info" }, [
          _vm._v("ดูรายละเอียด")
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62cb2c9e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62cb2c9e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobPost/JobPostItem.vue
// module id = 2202
// module chunks = 0